import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeFourComponent implements OnInit {
  pt_news: string = 'pt-100';
  pt: string = 'pt-0';
  pb: string = 'pb-70'; 
  ptb: string = 'ptb-100'; 
  section: string = 'landing'; 
  search:string=''

  constructor(private router: Router) { }

  searchService(): void {
    this.router.navigateByUrl('/services/directory', { state: { data: this.search}});
  }

  ngOnInit(): void {
  }

}
